
export const formatPhone = (value, previousValue) => {
  // return nothing if no value
  if (!value) return value;

  // only allows 0-9 inputs
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {

    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue;

    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;

    // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  }
};

const formatNumericOnly = (value) => {
  // return nothing if no value
  if (!value) {
    return value;
  }

  return value.replace(/[^\d]/g, '');
}

export const formatInternationalPhone = (value) => {
  return formatNumericOnly(value);
};

export const formatZip = (value) => {
  return formatNumericOnly(value);
};

/* Formats a date entered as 8 digits to MM/DD/YYYY, such as 01012025 -> 01/01/2025, does update as the user types it in */
export const formatDate = (date, previousDate) => {
  // return nothing if no value
  if (!date) return date;

  // only allows 0-9 inputs
  const currentDate = date.replace(/[^\d]/g, '');
  const cvLength = currentDate.length;

  if (!previousDate || date.length != previousDate.length) {

    // returns: "M", "MM"
    if (cvLength < 3) return currentDate;

    // returns: "MM/", "MM/D", "MM/DD"
    if (cvLength < 6) return `${currentDate.slice(0, 2)}/${currentDate.slice(2)}`;

    // returns: "MM/DD/", "MM/DD/Y", "MM/DD/YY", "MM/DD/YYY", "MM/DD/YYYY"
    return `${currentDate.slice(0, 2)}/${currentDate.slice(2, 4)}\/${currentDate.slice(4, 8)}`;
  }
};

